import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

import SidebarBrandLogo from "./SidebarBrandLogo";
import SidebarIcon from "./SidebarIcon";
import { sidebarIcons } from "./sidebarIcons";
import sidebarStyles from "./SidebarLayout.module.css";
import styles from "./MenuDrawerHeader.module.css";

type MenuDrawerHeaderProps = {
  variant: "drawer" | "docked";
  compact?: boolean;
  onClose?: () => void;
};

function MenuDrawerHeader({
  variant,
  compact = false,
  onClose,
}: MenuDrawerHeaderProps): React.JSX.Element {
  const { t } = useTranslation();

  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  return (
    <div className={styles.wrapper}>
      {variant !== "docked" && (
        <div
          className={clsx(
            sidebarStyles.sidebarIconAlignRow,
            styles.head,
            compact && styles.headCompact
          )}
        >
          {!compact && <SidebarBrandLogo />}
        </div>
      )}
      {variant === "drawer" && (
        <button
          type="button"
          className={clsx(
            sidebarStyles.sidebarIconAlignRow,
            styles.drawerCloseButton
          )}
          onClick={handleClose}
          aria-label={t("menu.close")}
        >
          <SidebarIcon
            icon={sidebarIcons.closeDrawer}
            className={styles.iconButtonGlyph}
          />
        </button>
      )}
    </div>
  );
}

export default MenuDrawerHeader;
